import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import _ from 'helpers/no_conflict_lodash';

import SelectionDetails from 'components/selection_details';
import SelectableRecordTable from "components/selectable_record_table/selectable_record_table";
import CompaniesTableHeader from './companies_table_header';
import CompanyRow from './company_row';

import {
  resetSelectedCompanies,
  resetSelectedCompaniesOnCurrentPage,
  toggleSelectAllCompanies,
  toggleSelectAllCompaniesOnCurrentPage
} from '../store/actions/select_list';
import { changeCompanyPage, changeCompanySort } from '../store/actions/query';
import { retrieveCompanies } from '../store/actions/search';
import { updatePreviewData } from '../store/actions/ui';

export class CompaniesTable extends React.Component {
  static propTypes = {
    changePage: PropTypes.func.isRequired,
    changeSort: PropTypes.func.isRequired,
    companies: PropTypes.array.isRequired,
    companyIds: PropTypes.array.isRequired,
    contactPreviewProps: PropTypes.shape({
      displayActions: PropTypes.shape({
        slideOpen: PropTypes.string
      }).isRequired
    }).isRequired,
    previewOverlayCallId: PropTypes.bool,
    resetSelection: PropTypes.func.isRequired,
    resetSelectionOnCurrentPage: PropTypes.func.isRequired,
    retrieveCompanies: PropTypes.func.isRequired,
    selectedCompanyIds: PropTypes.array.isRequired,
    sort: PropTypes.string,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllOnCurrentPage: PropTypes.func.isRequired,
    updatePreviewData: PropTypes.func
  };

  static columnCount = 4;

  allSelected() {
    return _.every(this.props.companies, company => this.isSelected(company.id));
  }

  someSelected() {
    return _.some(this.props.companies, company => this.isSelected(company.id)) && this.props.companies.length > 0;
  }

  isSelected(companyId) {
    return this.props.selectedCompanyIds.indexOf(companyId) > -1;
  }

  includeSearchResults() {
    const { companies } = this.props;
    return companies && companies.length > 0 && companies[0].searchResults != null;
  }

  handleSortChange = (sortOption) => {
    const { changeSort, changePage, retrieveCompanies } = this.props;

    changeSort(sortOption);
    changePage(1);
    retrieveCompanies();
  }

  canPreview = () => {
    const {
      previewOverlayCallId
    } = this.props;

    return !previewOverlayCallId;
  };

  handleUpdatePreviewOverlay = (companyId) => {
    const {
      contactPreviewProps,
      updatePreviewData
    } = this.props;

    if (!this.canPreview()) return null;

    const { displayActions: { slideOpen } } = contactPreviewProps;

    updatePreviewData(companyId, "Contacts::Company");
    window[slideOpen]();
    sessionStorage.setItem("previewDisplay", true);
  };

  render() {
    const columnHeaders = (
      <CompaniesTableHeader
        includeSearchResults={this.includeSearchResults()}
        sort={this.props.sort}
        onSortChange={this.handleSortChange}
      />
    );

    return (
      <SelectableRecordTable
        columnHeaders={columnHeaders}
        selectAllChecked={this.allSelected(this.state)}
        selectNoneVisible={this.someSelected()}
        onResetSelection={this.props.resetSelectionOnCurrentPage}
        onSelectAllToggle={this.props.toggleSelectAllOnCurrentPage}
      >
        <SelectionDetails
          forTable
          label="company"
          selectedCount={this.props.selectedCompanyIds.length}
          totalCount={this.props.companyIds.length}
          onClearSelection={this.props.resetSelection}
          onSelectAll={this.props.toggleSelectAll}
        />
        {this.renderCompanies()}
      </SelectableRecordTable>
    );
  }

  renderCompanies() {
    const { companies } = this.props;

    return _.map(companies, company => (
      <CompanyRow
        canPreview={this.canPreview}
        company={company}
        key={company.id}
        selected={this.isSelected(company.id)}
        updatePreviewOverlay={this.handleUpdatePreviewOverlay}
      />
    ));
  }
}

const mapStateToProps = state => ({
  companies: state.search.companies,
  companyIds: state.search.meta.companies.allIds,
  contactPreviewProps: state.ui.contactPreviewProps,
  previewOverlayCallId: state.ui.previewOverlayCallId,
  selectedCompanyIds: state.selectList.selectedCompanyIds,
  sort: state.query.companySort
});

const mapDispatchToProps = {
  retrieveCompanies,
  updatePreviewData,

  changePage: changeCompanyPage,
  changeSort: changeCompanySort,
  resetSelection: resetSelectedCompanies,
  resetSelectionOnCurrentPage: resetSelectedCompaniesOnCurrentPage,
  toggleSelectAll: toggleSelectAllCompanies,
  toggleSelectAllOnCurrentPage: toggleSelectAllCompaniesOnCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesTable);
